<template>
  <div>
    <v-checkbox
      v-model="customer.isPersonalAndBusinessAddressSame"
      label="My business address is the same as my personal address"
      color="#0078A7"
      dense
      id="same-as-personal"
      @change="onChangeSameAsPrimary"
    >
    </v-checkbox>
    <div class="fields-wrapper">
      <div class="address">
        <v-text-field
          :disabled="customer.isPersonalAndBusinessAddressSame"
          dense
          filled
          rounded
          autocomplete="address-line1"
          v-model="customer.businessLine1"
          v-on:focus="clearFieldError('line1')"
          :rules="fieldRules.line1"
          :error-messages="
            formFieldsErrors.line1 || formFieldsErrors.defaultError
          "
          id="businessLine1"
        >
          <template v-slot:label>
            <p class="input-legend">{{ $t('addressDetail.line1') }}</p>
          </template>
          <template v-slot:message="{ message, key }">
            <span :key="key" id="line1Message" v-html="message"></span>
          </template>
        </v-text-field>
      </div>
      <div class="small-field">
        <v-text-field
          dense
          filled
          rounded
          validate-on-blur
          :disabled="customer.isPersonalAndBusinessAddressSame"
          autocomplete="address-line2"
          v-model="customer.businessLine2"
          v-on:focus="clearFieldError('businessLine2')"
          :error-messages="formFieldsErrors.businessLine2"
          id="businessLine2"
        >
          <template v-slot:label>
            <p class="input-legend" style="font-size: 13px;">{{ $t('addressDetail.line2') }}</p>
          </template>
          <template v-slot:message="{ message, key }">
            <span :key="key" id="line2Message" v-html="message"></span>
          </template>
        </v-text-field>
      </div>
      <div class="mobile-small-field-wrapper" v-if="isMobile">
        <div class="small-field">
          <v-text-field
            dense
            filled
            rounded
            :disabled="customer.isPersonalAndBusinessAddressSame"
            autocomplete="address-level2"
            v-model="customer.businessCity"
            v-on:focus="clearFieldError('businessCity')"
            :rules="fieldRules.city"
            :error-messages="formFieldsErrors.businessCity || formFieldsErrors.city"
            id="businessCity"
          >
            <template v-slot:label>
              <p class="input-legend">{{ $t('addressDetail.city') }}</p>
            </template>
            <template v-slot:message="{ message, key }">
              <span :key="key" id="cityMessage" v-html="message"></span>
            </template>
          </v-text-field>
        </div>
        <div class="small-field" id="business-state">
          <v-select
            v-model="customer.businessAddressState"
            :items="states"
            :rules="fieldRules.state"
            :disabled="customer.isPersonalAndBusinessAddressSame"
            item-text="title"
            item-value="id"
            label="Choose State"
            filled
            append-icon="mdi-chevron-down"
            :menu-props="{ contentClass: 'selectScroll'}"
          >
          <template v-slot:item="data">
            <p class="v-list-item__title" :id="data.item.id">{{ data.item.title }}</p>
          </template>
        </v-select>
        </div>
      </div>
      <div class="small-field" v-if="!isMobile">
          <v-text-field
            dense
            filled
            rounded
            :disabled="customer.isPersonalAndBusinessAddressSame"
            autocomplete="address-level2"
            v-model="customer.businessCity"
            v-on:focus="clearFieldError('businessCity')"
            :rules="fieldRules.city"
            :error-messages="formFieldsErrors.businessCity || formFieldsErrors.city"
            id="businessCity"
          >
            <template v-slot:label>
              <p class="input-legend">{{ $t('addressDetail.city') }}</p>
            </template>
            <template v-slot:message="{ message, key }">
              <span :key="key" id="cityMessage" v-html="message"></span>
            </template>
          </v-text-field>
        </div>
        <div class="small-field" id="business-state"  v-if="!isMobile">
          <v-select
            v-model="customer.businessAddressState"
            :items="states"
            :rules="fieldRules.state"
            :disabled="customer.isPersonalAndBusinessAddressSame"
            item-text="title"
            item-value="id"
            label="Choose State"
            filled
            append-icon="mdi-chevron-down"
            :menu-props="{ contentClass: 'selectScroll'}"
          >
          <template v-slot:item="data">
            <p class="v-list-item__title" :id="data.item.id">{{ data.item.title }}</p>
          </template>
        </v-select>
        </div>
      <div class="small-field">
        <v-text-field
          dense
          filled
          rounded
          :disabled="customer.isPersonalAndBusinessAddressSame"
          autocomplete="postal-code"
          v-model="customer.businessPostalCode"
          v-on:focus="clearFieldError('businessPostalCode')"
          :rules="fieldRules.zip"
          :error-messages="formFieldsErrors.businessPostalCode"
          inputmode="numeric"
          v-mask="'#####'"
          id="businessPostalCode"
        >
          <template v-slot:label>
            <p class="input-legend">
              {{ $t('addressDetail.postalCode') }}
            </p>
          </template>
          <template v-slot:message="{ message, key }">
                <span
                  :key="key"
                  id="postalCodeMessage"
                  v-html="message"
                ></span>
          </template>
        </v-text-field>
      </div>
    </div>
  </div>
</template>

<script>
import {params} from '../../../localData'

export default {
  name: 'BusinessAddressForm',
  beforeMount () {
    this.customer = {...this.customerData}
  },
  watch: {
    customer: {
      handler (newVal) {
        this.$store.commit('customer/setKeyValue', {prop: 'businessLine1', value: newVal.businessLine1})
        this.$store.commit('customer/setKeyValue', {prop: 'businessLine2', value: newVal.businessLine2})
        this.$store.commit('customer/setKeyValue', {prop: 'businessCity', value: newVal.businessCity})
        this.$store.commit('customer/setKeyValue', {prop: 'businessPostalCode', value: newVal.businessPostalCode})
        this.$store.commit('customer/setKeyValue', {prop: 'businessAddressState', value: newVal.businessAddressState})
        this.$store.commit('customer/setKeyValue', {prop: 'isPersonalAndBusinessAddressSame', value: newVal.isPersonalAndBusinessAddressSame})
      },
      deep: true
    }
  },
  computed: {
    formFieldsErrors () {
      return this.$store.getters['errors/fieldErrors']
    },
    customerData () {
      return this.$store.getters['customer/data']
    },
    isMobile () {
      return this.$store.getters['onboarding/isMobile']
    }
  },
  methods: {
    onChangeSameAsPrimary (checked) {
      if (checked) {
        this.customer.businessLine1 = this.customer.line1
        this.customer.businessLine2 = this.customer.line2
        this.customer.businessCity = this.customer.city
        this.customer.businessPostalCode = this.customer.postalCode
        this.customer.businessAddressState = this.customer.state
      } else {
        this.customer.businessLine1 = ''
        this.customer.businessLine2 = ''
        this.customer.businessCity = ''
        this.customer.businessPostalCode = ''
        this.customer.businessAddressState = ''

        this.clearFieldError('businessLine1')
        this.clearFieldError('businessLine2')
        this.clearFieldError('businessCity')
        this.clearFieldError('businessPostalCode')
        this.clearFieldError('businessAddressState')
      }
    },
    clearFieldError (field) {
      this.$store.dispatch('errors/clearSpecificFieldError', [
        'defaultError',
        field
      ])
    }
  },
  data () {
    return {
      states: params.states,
      customer: {},
      flags: {
        isChecked: false
      },
      fieldRules: {
        line1: [
          v => !!v || this.$t('validation.custom.line1.required'),
          v => (v && v.length > 1) || this.$t('validation.custom.line1.min'),
          v => (v && v.length <= 40) || this.$t('validation.custom.line1.max'),
          v =>
            /^[A-Za-z0-9-\s]+$/.test(v) ||
            this.$t('validation.custom.line1.regex')
        ],
        zip: [
          v => !!v || this.$t('validation.custom.postalCode.required'),
          v =>
            (v && v.length > 4) ||
            this.$t('validation.custom.postalCode.length')
        ],
        city: [
          v => !!v || this.$t('validation.custom.city.required'),
          v => (v && v.length > 1) || this.$t('validation.custom.city.min'),
          v => (v && v.length < 21) || this.$t('validation.custom.city.max'),
          v =>
            /^[A-Za-z\s]+$/.test(v) || this.$t('validation.custom.city.format')
        ],
        state: [v => !!v || 'State is required']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.demi-checkbox-wrapper {
  margin-bottom: 32px;
}
.fields-wrapper {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 0px 24px;
  align-items: start;
}

.fields-wrapper .address {
  width: 330px;
}
.fields-wrapper .small-field {
  width: 153px;
}
.mobile-small-field-wrapper {
  display: inline-block;
}

@media only screen and (max-width: 480px) {
  .fields-wrapper {
    gap: 0px 0px;
    .address, .small-field {
      width: 100%;
    }
    .mobile-small-field-wrapper {
      display: flex;
      flex-direction: row;
      gap: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PartnerOnboarding/business-sections/BusinessAddressForm.vue